/************  GESTION DE LA NAVIGATION *****************/

    $('document').ready(setupNav);
    let scrollPosition = 0;
    let lastScrollTop = 0;

    function setupNav() {
        // Fonction pour gérer la navigation
        initBurgerMenu();
        initMenu();
        stickyMenu();
        initMainSiteMenu();
        initMainSiteSearchBox();
    }

    // Affichage des sous menu (mega menus) en responsive
    function initMenu() {
        $('.has-childrens > a, .has-childrens > .top-item, .has-childrens > .btn-drop').click(function(e) {
            if($(window).width() < 1200) {
                e.preventDefault();
                if($(this).parent().hasClass('active')) {
                    $(this).parent().removeClass('active');
                    $(this).parent().children('.sub-menu').slideUp(400);
                }else {
                    $('.menu li.active').removeClass('active')
                    $(this).parent().addClass('active');
                    $('.sub-menu').slideUp(400);
                    $(this).parent().children('.sub-menu').slideDown(400);
                }
            }
        });
        
        // Affichage des sous-sous menu en responsive
        $('.navigation .submenu-has-children .btn-drop').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().parent().children('.sub-child-menu').slideUp(400);
            }else {
                $(this).addClass('active');
                $(this).parent().parent().children('.sub-child-menu').slideDown(400);
            }
        });
        
        $('.menu li.dropdown').click(function() {
            if($(window).width() >= 1200) {
                if($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).children('.sub-menu').slideUp(400);
                }else {
                    $(this).addClass('active');
                    $(this).children('.sub-menu').slideDown(400);
                }
            }
        })
    }

    function initBurgerMenu() {
        $('.navigation .burger').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.translatecontent').removeClass('scale');
                $('.navigation').removeClass('open');
                $('html, body').removeAttr('style');
                $('body').scrollTop(scrollPosition);
            }else {
                scrollPosition = $(window).scrollTop();
                $(this).addClass('active');
                $('.navigation').addClass('open');
                $('.translatecontent').addClass('scale');
                $('.navigation').removeClass('hide');
                $('html, body').css('overflow', 'hidden');
            }
        });
    }
    
    function initMainSiteMenu() {
        $('.burger-main, .mainsitenav .burger').click(function() {
            if($('.perspectivecontainer').hasClass('slide')) {
                $('html, body').removeAttr('style');
                $('.perspectivecontainer').removeClass('slide');
                $('.translatecontent').removeClass('slide');
                $('.navigation').removeClass('slide');
                setTimeout(function() {
                    $('body').removeClass('perspective');
                    $('body').scrollTop(scrollPosition);
                }, 400);
            }else {
                scrollPosition = $(window).scrollTop();
                $('html, body').css('overflow', 'hidden');
                $('body').addClass('perspective');
                $('.translatecontent').removeClass('scale');
                $('.perspectivecontainer').addClass('slide');
                $('.translatecontent').addClass('slide');
                $('.navigation').addClass('slide');
            }
        });
        
        $('.mainsitenav-menu .has-childrens > a, .mainsitenav-menu .has-childrens > .btn-drop').click(function(e) {
            e.preventDefault();
            if($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
                $(this).parent().children('.sub-menu').slideUp(400);
            }else {
                $('.menu li.active').removeClass('active')
                $(this).parent().addClass('active');
                $('.sub-menu').slideUp(400);
                $(this).parent().children('.sub-menu').slideDown(400);
            }
        });
        
        // Affichage des sous-sous menu en responsive
        $('.mainsitenav-menu .submenu-has-children .btn-drop').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().parent().children('.sub-child-menu').slideUp(400);
            }else {
                $(this).addClass('active');
                $(this).parent().parent().children('.sub-child-menu').slideDown(400);
            }
        });
    }

    // Affichage de la recherche dans le centre documentaire
    function initMainSiteSearchBox() {
        $('.mainsitenav-search .btn-search').click(function() {
            if($('.burger').hasClass('active')) $('.burger').click();
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.mainsitenav-search .searchdocs').slideUp(300);
            }else {
                $(this).addClass('active');
                $('.mainsitenav-search .searchdocs').slideDown(300);
            }
        });
    }

    function stickyMenu() {
        $(window).scroll(function() {
            if($(this).scrollTop() >= 50) {
                if(!$('.navigation').hasClass('sticky')) $('.navigation').addClass('hide');
                $('.navigation').addClass('sticky');
                // Afficher le menu au scroll vers le haut en mobile seulement
                var st = $(this).scrollTop();
                if (st < lastScrollTop){
                    $('.navigation').removeClass('hide');
                    $('.summary.fixed').addClass('afterNav');
                }else {
                    $('.navigation').addClass('hide');
                    $('.summary.fixed').removeClass('afterNav');
                }
                lastScrollTop = st;
            }else {
                $('.navigation').removeClass('sticky hide');
            }
            
            
            if($(this).scrollTop() >= 200) {
                $('.btn-topage').addClass('show');
            }else {
                $('.btn-topage').removeClass('show');
            }
        });
    }